import { render, staticRenderFns } from "./sqfwCard.vue?vue&type=template&id=677beee2&scoped=true&"
import script from "./sqfwCard.vue?vue&type=script&lang=js&"
export * from "./sqfwCard.vue?vue&type=script&lang=js&"
import style0 from "./sqfwCard.vue?vue&type=style&index=0&id=677beee2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677beee2",
  null
  
)

export default component.exports